module.exports = require("compression");


//////////////////
// WEBPACK FOOTER
// external "compression"
// module id = 22
// module chunks = 0